<template>
  <div class="content"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>    
    <template>
      <v-toolbar flat class="rounded-lg">
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-family-tree</v-icon>List {{this.$store.state.title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex lg3>
          <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn  v-show=insertact outlined rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
              Add New 
              <v-icon class="ml-2">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
            </v-card-title>
            <v-card-text style="height: auto;" class="overflow-card">
                <v-form class="ml-2" ref="form" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined dense v-model="org_display_name" 
                        :rules="displaynamerules" required label="Organization display name" 
                        hint="Input organization display name" persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select outlined dense :items="itemsactivate" item-text="name_active" item-value="valueactive" v-model="statusactive"  label="Public Status"></v-select>
                      </v-col>
                      
                      <v-col  cols="12" sm="12" md="12"> 
                        <!-- <input dense outlined chips accept="image/*" type="file"  ref="file" @change="selectfile"> -->
                        <v-file-input
                          outlined
                          v-model="file"
                          dense
                          label="Upload Image"
                          accept="image/*"
                          @change="selectfile"
                          @click:clear="onClear"
                          prepend-icon="mdi-image"
                        ></v-file-input>
                        <v-img v-if="previewImage" :src="previewImage" max-height="200" contain></v-img>
                      </v-col>
                      <v-col  cols="12" sm="12" md="12">
                        <v-text-field outlined dense label="User Profile Image URL" v-model="image_url" :rules="userprofilrules" 
                        hint="Input URL of image" persistent-hint>
                        </v-text-field>
                        
                      </v-col>
                      
                      
                      <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in item_alians" :key="index">
                        <v-flex lg8>
                          <v-text-field outlined dense v-model="item.alias" label="User Alias" :rules="aliasRules"></v-text-field>
                        </v-flex>
                        <v-flex lg4>
                          
                          <v-btn 
                              class="mx-2 elevation-0" 
                              dark 
                              outlined 
                              icon 
                              :color="'#0471A5'"  

                              @click="checkedalias(item,index)"
                            >
                              <v-icon class="rounded-icon">{{ item.priority == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                          </v-btn>
                          <v-btn class="red elevation-0"  @click="remove(item, index)" outlined color="#fff" icon><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </v-flex>
                        
                      </v-row>
                      
                      <v-col cols="12" sm="12" md="12">
                            <v-btn 
                            class="blue darken-1"
                            style="width: 160px;" rounded dark dense  
                            @click="add()"
                            
                            >
                              <v-icon>mdi-plus</v-icon> Add Alias
                            </v-btn>
                      </v-col>
                      
                    </v-row>
                  </v-container>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="py-3">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="330px">
          <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
            <v-avatar class="color-avatar3 my-4" size="62">
              <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
            </v-avatar>
            <div class="text-center text-h6 align-center justify-center font-weight-medium">
              Confirm Deletion
            </div>
            <v-card-text class="align-center justify-center mt-2">
              Are you sure you want to permanently delete this item?
            </v-card-text>
            <v-divider class="mt-4" style=""></v-divider>
            <v-card-actions class="align-center justify-center">
              <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                OK
              </v-btn>
              <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                Cancel 
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <v-data-table 
      :headers="headers"
      :items="organization"
      :search="search"
      sort-by="org_display_name"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
      <template v-slot:[`item.image`]="{ item }">
        <v-img :src="item.LINK_ORG_IMAGE" style="width: 60px;" />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2"  v-show=updateact  @click="editItem(item.SEQ_ID)">
          mdi-pencil
        </v-icon>
        <v-icon small  v-show=deleteact @click="deleteItem(item.SEQ_ID)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios"
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: false,
        insertact: false,
        updateact: false,
        viewact: false,
      displaynamerules: [
          v => !!v || ' Organization display name is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input hanya boleh berisi huruf, angka, spasi, dan spesial caracter (.@_-)',
        ],
        
      aliasRules: [
        v => !!v || 'Alias is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      // orgaliasrules: [
      //     v => !!v || ' Organization Alias is required',
      //     v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input hanya boleh berisi huruf, angka, spasi, dan spesial caracter (.@_-)',
      //   ],
        
      statusactive: 0,
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Active" },
        {valueactive: 0, name_active: "Disabled" }
      ],
      activate: ['Active', 'Disable'],
      usertype: ['Twitter'],
      dialog: false,
      dialogDelete: false,
      search:'',
      headers: [
        { text: 'DISPLAY NAME', value: 'ORG_DISPLAY_NAME' },
        // { text: 'ALIAS', value: 'ORG_ALIAS' },
        { text: 'ALIAS', value: 'NER_ALIAS' },

        { text: 'IMAGE', value: 'image' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      organization: [],
      id_organization: "",
      editedIndex: -1,
      org_display_name: "",
      org_alias: "",
      ner_alias: "",
      // arr_alias: [
      // ],

      item_alians: [
        {alias : '',id_alias : '' ,priority: true}
      ],
      file: "",
      previewImage: "",
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Add '+this.$store.state.title : 'Update '+this.$store.state.title 
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
      // this.tableLoading = true;

    },
    methods: {
    
      checkedalias(item, index) {
        // Uncheck all other items
        this.item_alians.forEach((alias, idx) => {
          if (idx !== index) {
            alias.priority = false;
          }
        });

        // Toggle the clicked item
        this.$set(this.item_alians, index, { ...item, priority: !item.priority });

        console.log(this.item_alians);
      },

      add() {
        this.originalData = null
        this.item_alians.push({ alias: '' ,id_alias: '' ,priority: false })
        // this.editIndex = this.item_insert_dinamis.length - 1
      },
      remove(item, index) {
        // if(item.id_alias != null){
        // }
        if(index > 0){
          this.item_alians.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
      selectfile(event) {
        this.file = event;
        if (event) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(event);
        }
      },
        
      onClear() {
        this.previewImage='';
        this.file = null; // bisa juga reset data lainnya jika perlu
      },
      initialize () {
        this.tableLoading = true;
        axios.get("data_organization",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.organization = decryptionData(response.data.token);
            
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      editItem (item) {
        this.id_organization = item
        this.editedIndex = 1

        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "data_organization_Id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then(async (response) => {
            // console.log(response.data);
            let result = decryptionData(response.data.token);

            const data = result.data;
            const alias = result.alias_organization;
            this.org_display_name =data.ORG_DISPLAY_NAME;
            this.org_alias =data.ORG_ALIAS;
            //this.file ='';
            
            if (data.ORG_IMAGE) {

              const imageUrl = data.ORG_IMAGE;

              try {
                const response = await axios.get(imageUrl, {
                  responseType: 'blob',
                });

                const blob = response.data;
                const filename = imageUrl.split('/').pop();
                const file = new File([blob], filename, { type: blob.type });
                this.file = file;
                this.previewImage = URL.createObjectURL(file); // opsional preview
              } catch (err) {
                console.error("Gagal ambil gambar dari server:", err);
                this.file = null;
                this.previewImage = '';
              }
              // this.file = file;
              // this.previewImage = URL.createObjectURL(file); // tampilkan preview
            } else {
              this.file = null;
              this.previewImage = '';
            }

            // let arr_data = [];
            // if(alias.length > 0){
            //   for (let i = 0; i <  alias.length; i++) { 
            //     this.addAlias(); 
            //       arr_data.push(alias[i].NER_ALIAS);
            //   }
            //     this.item_alians = arr_data;
            // }else{
            //       this.item_alians =[ {alias : '',id_alias : '' ,priority: true}];
                  
            // }
            

            
            let arr_data = [];
            let allPriorityZero = alias.every(item => item.PRIORITY === 0);
            if(alias.length > 0){
              for (let i = 0; i <  alias.length; i++) { 
                this.add(); 
                var priority = false
                                // Jika item pertama dan semua PRIORITY = 0, set priority = true
                if (allPriorityZero && i === 0) {
                  priority = true;
                } else if (alias[i].PRIORITY === 1) {
                  // Jika PRIORITY = 1, set priority = true
                  priority = true;
                }
                // if(alias[i].PRIORITY == 1){
                //   priority = true
                // }
                arr_data.push({alias: alias[i].NER_ALIAS ,id_alias: alias[i].SEQ_ID, priority: priority});
              }
                this.item_alians = arr_data;
                   
            }else{
                this.item_alians =[];
                this.item_alians.push({ alias: '' ,id_alias: '' ,priority: true })
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      deleteItem (item) {
        this.id_organization = item
        this.editedIndex = this.organization.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.organization.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "data_organization/delete",
          data: {
            seq_id: this.id_organization
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
        this.closeDelete()
      },
      close () {
        this.file='';
        this.id_organization='';
        this.org_display_name='';
        this.org_alias='';
        // this.arr_alias=[];
        this.item_alians =[ {alias : '',id_alias : '' ,priority: true}];

        this.onClear() 
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      selectFile() {
        this.file = this.$refs.file.files[0];
      },
      // addAlias() {
      //   if (this.ner_alias.length && !this.arr_alias.includes(this.ner_alias)) {
      //     this.arr_alias.push(this.ner_alias)
      //     this.ner_alias = ""
      //   }
      // },
      // removeAlias(item) {
      //   this.arr_alias.splice(this.arr_alias.indexOf(item), 1)
      // },
      async save () {     
        const isValid = this.$refs.form.validate();
         var arr_alias = []
        var seq_id_alias = []
        var priority = []
        for (var alias of this.item_alians) {
          arr_alias.push(alias.alias)
          seq_id_alias.push(alias.id_alias)
          priority.push(alias.priority)
        }

        const formData = new FormData();
        formData.append(`image`,this.file);
        formData.append('seq_id', this.id_organization);
        formData.append('org_display_name', this.org_display_name);
        formData.append('org_alias', this.org_alias);
        // formData.append('arr_alias', this.arr_alias);

        formData.append('priority', priority);
        formData.append('data_alias', JSON.stringify(this.item_alians));

        formData.append('public_status', this.statusactive);
        for (var item of formData.entries()) {
            console.log(item[0]+ ', ' + item[1]); 
        }
            if (this.editedIndex > -1) {
              if (isValid) {
                this.btnload = true
                  await axios.put("data_organization/update",formData, 
                    { headers:
                      {
                        'auth-token':localStorage.getItem('token_app'),
                        'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                      }
                    },
                    {dataType: 'json'},
                    )
                  .then((response) => {
                      var status = response.data.status
                      var messages = response.data.msg
                      if(status == 200){
                        this.initialize();
                        this.$router.push('/organization');
                        this.alertSuccess = true;
                        this.alert_err_attention =  messages;
                        this.btnload = false
                        this.close()
                      }else{
                          this.alertFailed = true;
                          this.alert_err_attention =  messages;
                          this.btnload = false
                      } 
                    })
                  .catch((e) => {
                        switch (e.response.status) {
                            case 404:
                                  this.$refs.alert.error_login(404);
                                break;
                            case 403:
                                  this.$refs.alert.error_login(403);
                                break;
                            case 400:
                                  this.alertFailed = true;
                                  this.alert_err_attention =  e.response.data.msg;
                                  this.btnload = false
                                break;
                            default:
                                console.log('some other error');  // end up here all the time
                                break;
                            }
                    this.errors=e.response.data.msg;
                  });
              }
            } else {
              if (isValid) {
                  this.btnload = true
                  this.organization.push(this.editedItem)
                  await axios.post("data_organization/insert",formData, 
                    { headers:
                      {
                        'auth-token':localStorage.getItem('token_app'),
                        'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                      }
                    },
                    {dataType: 'json'},
                    )
                  .then((response) => {
                      var status = response.data.status
                      var messages = response.data.msg
                      if(status == 200){
                        this.initialize();
                        this.$router.push('/organization');
                        this.alertSuccess = true;
                        this.alert_err_attention =  messages;
                        this.btnload = false
                        this.close()
                      }else{
                          this.alertFailed = true;
                          this.alert_err_attention =  messages;
                          this.btnload = false
                      } 
                    })
                  .catch((e) => {
                        switch (e.response.status) {
                            case 404:
                                  this.$refs.alert.error_login(404);
                                break;
                            case 403:
                                  this.$refs.alert.error_login(403);
                                break;
                            case 400:
                                  this.alertFailed = true;
                                  this.alert_err_attention =  e.response.data.msg;
                                  this.btnload = false
                                break;
                            default:
                                console.log('some other error');  // end up here all the time
                                break;
                            }
                    this.errors=e.response.data.msg;
                  });
                }
            }
      },
    },
  }
</script>


<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>